import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 7, viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.6234 0.430775C9.9486 0.109175 10.4742 0.109175 10.797 0.430775C11.121 0.752375 11.1234 1.27197 10.797 1.59357L6.1074 6.18957C5.7834 6.51117 5.259 6.51117 4.9326 6.18957L0.243 1.59357C-0.081 1.27318 -0.081 0.752375 0.243 0.430775C0.5682 0.109175 1.0938 0.109175 1.4166 0.430775L5.5218 4.19997L9.6234 0.430775Z", fill: "black" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
